import { type CandidatesTranslations } from './candidates.translations.pl.ts';

export const candidatesTranslations: CandidatesTranslations = {
  columns: {
    areas: 'Areas',
    candidate: 'Candidate',
    decisionDue: 'Decision due',
    quizFinished: 'Quiz finished',
    score: 'Score',
    status: 'Status',
    statusChanged: 'Last change',
    studies: 'University and internship location',
  },
  filters: {
    area: 'Area',
    clear: 'Clear filters',
    decisionFrom: 'Decision from',
    decisionTo: 'Decision until',
    location: 'Internship location',
    score: 'Quiz score',
  },
  noResults: 'No candidates match the criteria',
  overdue: 'overdue',
  profile: {
    about: 'About',
    activeTime: 'Time in the quiz',
    areas: 'Areas of interest',
    categories: 'Results by category',
    close: 'Close',
    fair: 'Job fair',
    fieldOfStudy: 'Field of study',
    finished: 'Finished',
    justification: "Why these areas (in the candidate's words)",
    language: "Candidate's language",
    loadError: "The candidate's profile could not be loaded.",
    location: 'Internship location',
    minutes: '{{value}} min',
    no: 'no',
    noQuiz: 'The candidate has not started the quiz yet.',
    points: 'Points',
    quiz: 'Quiz',
    registered: 'Registered',
    skillLevels: ["doesn't know", 'beginner', 'basic', 'good', 'advanced'],
    skills: 'Self-assessed skills',
    skillTypes: {
      LANGUAGE: 'Languages',
      PROGRAMMING_LANGUAGE: 'Programming languages',
      SYSTEM_TECHNOLOGY_METHODOLOGY: 'Systems, technologies and methodologies',
      TOOL: 'Tools',
    },
    started: 'Started',
    studentStatus: 'Status',
    studies: 'Studies',
    timeline: 'Process history',
    typeOfStudy: 'Type of studies',
    under30: 'Under 30',
    university: 'University',
    yearOfStudy: 'Year of studies',
    yes: 'yes',
  },
  quickFilters: {
    afterQuiz: 'After the quiz',
    all: 'All',
    fromFair: 'From job fairs',
    inProgress: 'In progress',
    negative: 'Negative',
    onHold: 'On hold',
    positive: 'Positive',
    stopped: 'Stopped',
  },
  search: 'Search by last name, e-mail or phone',
  sortBy: 'Sort by: {{column}}',
  timeLeft: '{{time}} left',
  timelineEvents: {
    ACCOUNT_CREATION: 'Account created',
    ADMIN_DOWNLOAD_FULL_AUDIT: 'Admin downloaded the full audit',
    ADMIN_DOWNLOAD_PROCESS_DETAILS: 'Admin downloaded the process file',
    ADMIN_POSITIVE_FEEDBACK_CHANGE: 'Admin changed the decision to positive',
    ADMIN_SET_NEGATIVE_FEEDBACK: 'Admin set a negative decision',
    ADMIN_SET_ON_HOLD: 'Admin put the decision on hold',
    CANDIDATE_SENT_TO_ALL_EXTERNAL_RECRUITMENTS: 'Sent to eRecruiter',
    EMAIL_SENT_ADMIN_FAIR_CANDIDATE_QUIZ_FINISHED: 'Admin notification: job fair candidate',
    EMAIL_SENT_ADMIN_LOGIN: 'Admin panel login e-mail',
    EMAIL_SENT_ADMIN_ON_HOLD_REMINDER: 'Admin notification: on-hold reminder',
    EMAIL_SENT_CANDIDATE_BACK_TO_APP_ACTIVE_PROCESS_NOT_ON_QUIZ: 'E-mail: back to the app',
    EMAIL_SENT_CANDIDATE_BACK_TO_APP_QUIZ_EXPIRED: "E-mail: quiz time's up",
    EMAIL_SENT_CANDIDATE_BACK_TO_QUIZ: 'E-mail: back to the quiz',
    EMAIL_SENT_CANDIDATE_END_OF_PROCESS: 'E-mail: application received',
    EMAIL_SENT_CANDIDATE_LACK_OF_ACTIVITY: 'E-mail: inactivity reminder',
    EMAIL_SENT_CANDIDATE_NOT_ACTIVE_PROCESS_FEEDBACK_SENT: 'E-mail: process finished',
    EMAIL_SENT_CANDIDATE_NOT_ACTIVE_PROCESS_WAITING_FOR_FEEDBACK: 'E-mail: waiting for the decision',
    EMAIL_SENT_CANDIDATE_ON_HOLD_NEEDS_MORE_TIME: 'E-mail: we need more time',
    EMAIL_SENT_CANDIDATE_ONBOARDING: 'Welcome e-mail',
    EMAIL_SENT_NEGATIVE_FEEDBACK: 'Negative feedback e-mail',
    EMAIL_SENT_POSITIVE_FEEDBACK: 'Positive feedback e-mail',
    other: 'Event',
    PERSONAL_DATA_WITH_AREA_OF_INTEREST_SUBMISSION: 'Personal data and areas of interest sent',
    PERSONAL_DATA_WITH_AREA_OF_INTEREST_UPDATE: 'Personal data and areas of interest changed',
    QUIZ_FINISHED: 'Quiz finished',
    QUIZ_INITIALIZATION: 'Quiz started',
    QUIZ_SUBMISSION: 'Quiz submitted',
    SKILLS_ASSESSMENT_SUBMISSION: 'Skills self-assessed',
    USER_LOGGED_IN: 'Logged in',
  },
  title: 'Candidates',
};
